import { ActivityLog } from '@tools/interfaces/activity-log';
import { get } from 'lodash';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-activity-short-info',
  components: {},
})
export default class ActivityShortInfo extends Vue {
  @Prop(Object) readonly item: ActivityLog;
  @Prop({ type: Boolean, default: false }) readonly bookingEvent: boolean;

  get code(): string {
    const code = get(this.item, 'subject.code', null);
    return code || get(this.item, 'subject.reference', null);
  }

  get name(): string {
    return get(this.item, 'subject.name', null);
  }

  get type(): string {
    return get(this.item, 'subject_type_name', null);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
